import { Card, CardContent } from "@mui/material";
import { FilterList, FilterListItem, FilterLiveSearch, SavedQueriesList } from "react-admin";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import { UserStatus } from "@/types";
import { formatToTitleCase } from "@/utils/formatters/stringFormatters";

export const UsersListAside = () => {
  const statuses = [
    { label: formatToTitleCase(UserStatus.ACTIVE), value: UserStatus.ACTIVE },
    { label: formatToTitleCase(UserStatus.INACTIVE), value: UserStatus.INACTIVE },
    { label: formatToTitleCase(UserStatus.PENDING), value: UserStatus.PENDING },
    { label: formatToTitleCase(UserStatus.DISABLED), value: UserStatus.DISABLED },
    { label: formatToTitleCase(UserStatus.SUSPENDED), value: UserStatus.SUSPENDED },
  ];

  const titles = ["Claims Analyst", "Manager", "Admin"];

  return (
    <Card
      sx={{
        display: {
          xs: "none",
          md: "block",
        },
        order: -1,
        flex: "0 0 20em",
        mr: 2,
        mt: 6,
        alignSelf: "flex-start",
      }}
    >
      <CardContent sx={{ pt: 1 }}>
        <FilterLiveSearch />
        <SavedQueriesList />
        <FilterList label="Title" icon={<BadgeIcon />}>
          {titles.map((item, idx) => {
            return <FilterListItem key={idx} label={item} value={{ job_title: item }} />;
          })}
        </FilterList>
        <FilterList label="Status" icon={<PsychologyAltIcon />}>
          {statuses.map((item, idx) => {
            return <FilterListItem key={idx} label={item.label} value={{ status: item.value }} />;
          })}
        </FilterList>
      </CardContent>
    </Card>
  );
};
